import { useMemo } from 'react';
import { useContent } from '../../../../../redux/reducer/content';
import { useUser } from '../../../../../redux/reducer/user';
import { giftNoticeClothContent } from '../../../../../constants/copyright-modals';

export default function useGiftClothesModal() {
  const { profile } = useUser();
  const { notFilteredShopItems } = useContent();

  return useMemo(() => {
    if (!profile?.items || !notFilteredShopItems) return [];

    return profile.items.reduce((acc, shopItem) => {
      if (shopItem.is_gift)
        acc.push({
          id: `giftItem${shopItem?.id}`,
          type: 'giftNotice',
          props: {
            ...giftNoticeClothContent,
            images: [notFilteredShopItems?.find?.(({ id }) => shopItem.id === id)?.preview_image],
            name: shopItem.gifted_by_user,
            uid: shopItem.gifted_by,
          },
        });
      return acc;
    }, []);
  }, [profile?.items, notFilteredShopItems]);
}
